import gql from 'graphql-tag';
import { COUPON_FRAGMENT } from './coupon';

/** 会员计划 */
export const MEMBERSHIPPLAN_FRAGMENT = gql`
  fragment MembershipPlan on MembershipPlan {
    id
    createdAt
    updatedAt
    name
    bannerImg
    backgroundImage
    protocolUsage
    validityPeriod {
      type
      startTime
      endTime
      numberOfDays
    }
    price
    introduce
    customerServiceNumber
    state
    rightsDiscount {
      enable
      discountRate
      restrictedUse
    }
    rightsPoints {
      enable
      pointsMultiple
    }
    rightsCoupon {
      enable
      presentedCoupon {
        couponId
        presentedCount
      }
    }
    membershipPlanCoupon {
      coupon {
        ...Coupon
      }
      quantity
    }
  }
  ${COUPON_FRAGMENT}
`;

/** 会员计划 - 不包含会员优惠券 */
export const NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT = gql`
  fragment MembershipPlan on MembershipPlan {
    id
    createdAt
    updatedAt
    name
    bannerImg
    backgroundImage
    protocolUsage
    validityPeriod {
      type
      startTime
      endTime
      numberOfDays
    }
    price
    introduce
    customerServiceNumber
    state
    rightsDiscount {
      enable
      discountRate
      restrictedUse
    }
    rightsPoints {
      enable
      pointsMultiple
    }
    rightsCoupon {
      enable
      presentedCoupon {
        couponId
        presentedCount
      }
    }
  }
`;

/** 会员 */
export const MEMBER_FRAGMENT = gql`
  fragment Member on Member {
    id
    createdAt
    updatedAt
    code
    claimAt
    activationAt
    maturityAt
    maturityType
    membershipPlan {
      ...MembershipPlan
    }
    state
  }
  ${NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT}
`;

/**
 * 礼品卡
 */
export const GIFT_CARD_FRAGMENT = gql`
  fragment GiftCard on GiftCard {
    id
    createdAt
    updatedAt
    name
    remarks
    backgroundImage
    price
    introduce
    state
    smallProgramQRCodeLink
    rightsCoupon {
      enable
      presentedCoupon {
        couponId
        presentedCount
      }
    }
    giftCardCoupon {
      quantity
      coupon {
        ...Coupon
      }
    }
    membershipPlan {
      ...MembershipPlan
    }
  }
  ${COUPON_FRAGMENT}
  ${MEMBERSHIPPLAN_FRAGMENT}
`;
